import { openBlock as u, createElementBlock as o, createElementVNode as r, toDisplayString as l, withDirectives as a, vModelText as c, normalizeClass as f, createCommentVNode as _ } from "vue";
import { _ as w } from "./chunks/_plugin-vue_export-helper.dad06003.js";
import './assets/QuestionForm.css';const h = {
  props: {
    interaction: {
      type: Object,
      require: !0
    },
    isQuerySuccess: {
      type: Boolean,
      require: !1,
      default: !0
    },
    isShowAlwaysSendButton: {
      type: Boolean,
      require: !1,
      default: !1
    }
  },
  emits: ["getAnswer", "selectInput", "unselectInput"],
  data() {
    return {
      answer: "",
      isAnswered: !1
    };
  },
  computed: {
    buttonText() {
      return this.isAnswered ? this.isQuerySuccess ? "Ответ отправлен" : "Отправка..." : "Отправить";
    }
  },
  methods: {
    selectInputHandler(t) {
      t ? (this.isAnswered = !1, this.$emit("selectInput")) : this.$emit("unSelectInput");
    },
    handleSend() {
      this.answer.length !== 0 && (this.isAnswered = !0, this.$emit("getAnswer", { answer: this.answer, ...this.interaction }));
    }
  },
  watch: {
    answer(t) {
      t.length > 0 && (this.isAnswered = !1);
    },
    isQuerySuccess(t) {
      t && (this.answer = "");
    }
  }
}, p = { class: "frisbuy-question" }, y = { class: "frisbuy-question__header" }, m = { class: "frisbuy-question__body" }, b = ["placeholder"];
function A(t, e, n, S, s, i) {
  return u(), o("div", p, [
    r("div", y, l(n.interaction.caption), 1),
    r("div", m, [
      a(r("input", {
        type: "text",
        class: "frisbuy-question__body-input",
        placeholder: n.interaction.placeholder,
        onClick: e[0] || (e[0] = () => i.selectInputHandler(!0)),
        onBlur: e[1] || (e[1] = () => i.selectInputHandler(!1)),
        "onUpdate:modelValue": e[2] || (e[2] = (d) => s.answer = d),
        maxlength: "80"
      }, null, 40, b), [
        [c, s.answer]
      ])
    ]),
    s.answer || s.isAnswered || n.isShowAlwaysSendButton ? (u(), o("button", {
      key: 0,
      class: f(["frisbuy-question__send-button", {
        "frisbuy-question__send-button--complete": s.isAnswered,
        "frisbuy-question__send-button--waiting": s.isAnswered && !n.isQuerySuccess
      }]),
      onClick: e[3] || (e[3] = () => i.handleSend())
    }, l(i.buttonText), 3)) : _("", !0)
  ]);
}
const g = /* @__PURE__ */ w(h, [["render", A], ["__scopeId", "data-v-bc2ff469"]]);
export {
  g as default
};
